@let _useMinimalLayout = useMinimalLayout();
@let _meetingPointers = meetingPointers();

@if (_useMinimalLayout) {
  @if (!!user) {
    <router-outlet> </router-outlet>
  }
} @else {
  <div class="flex h-full flex-col">
    <app-navbar
      *ngIf="!isForbidden()"
      [loaded]="themeLoaded$ | async"
      [title]="'home.title' | translate"
      [userGivenName]="userGivenName"
      [theme]="theme$ | async"
      [userHasRoles]="userHasRoles()"
      [allRolesActive]="allRolesActive$ | async"
      [mobileMenuItems]="mobileMenuItems | removeEmpty"
      [starredMenuItems]="starredMenuItems"
      [userMenuItems]="userMenuItems()"
      [helpMenuItems]="helpMenuItems$ | async"
      [configurationMenuItems]="configurationMenuItems"
      [exportsLength]="exportsLength$ | async"
      [printListModule]="printListModule"
      [calculationModule]="calculationModule"
      [menuOpen]="mobileMenuOpen"
      [countAnnouncements]="announcements.length"
      [countMeetingPointers]="_meetingPointers.length"
      [editModeEnabled]="false"
      (triggerSearch)="handleSearch($event)"
      (visibleChange)="toggleMobileMenu($event)"
      (showAnnouncements)="openAnnouncementDialog()"
      (showMeetingPointers)="openMeetingPointersDialog()"
      (logout)="logout()"
      [style.minHeight.rem]="3.75"></app-navbar>
    <div *ngIf="user || isForbidden()" id="main" class="router relative overflow-y-auto">
      <router-outlet> </router-outlet>
    </div>
    <app-footer [info]="footerInformation$ | async" [style.minHeight.rem]="1.5"></app-footer>

    <div class="toast-wrapper fixed flex flex-col">
      <app-toast></app-toast>
      <app-toast key="replace-message" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></app-toast>
    </div>
  </div>
}

<app-announcements-dialog
  *ngIf="showAnnouncementDialog"
  [visible]="showAnnouncementDialog"
  [announcements]="announcements"
  (closeAnnouncementDialog)="markAnnouncementsViewed($event)">
</app-announcements-dialog>
<app-announcements-dialog
  *ngIf="showNewAnnouncements"
  [visible]="showNewAnnouncements"
  [announcements]="newAnnouncements"
  (closeAnnouncementDialog)="markNewAnnouncementsViewed($event)">
</app-announcements-dialog>

<app-meetingpointers-dialog
  *ngIf="showMeetingPointersDialog"
  [(visible)]="showMeetingPointersDialog"
  [meetingPointers]="_meetingPointers">
</app-meetingpointers-dialog>

<app-voting></app-voting>

<app-walkthrough
  [visible]="(walkthrough$ | async)?.openedThroughMenu && !!(walkthrough$ | async)?.steps?.length"
  [steps]="(walkthrough$ | async)?.steps"
  (closeDialog)="handleCloseWalkthrough()"></app-walkthrough>
